export default __webpack_public_path__ + "media/mobile/app-a6d3a2c1.png";